module.exports = __webpack_public_path__ + "img/describe4.bdbaab4a.png";